import {Component, OnInit} from '@angular/core';
import {MetaTitle} from '../../../../../decorator/meta-title';
import {PostbackService} from '../../../../../services/postback/postback.service';
import {Postback} from '../../../../../models/postback/postback';
import {NgForOf, NgIf} from '@angular/common';
import {RouterLink} from '@angular/router';

@Component({
  selector: 'app-postback-list',
  imports: [
    NgForOf,
    RouterLink,
    NgIf
  ],
  templateUrl: './postback-list.component.html',
  styleUrl: './postback-list.component.scss'
})
@MetaTitle('Postbacks')
export class PostbackListComponent implements OnInit {

  protected postbacks: Postback[] = [];

  constructor(private readonly postbackService: PostbackService) {
  }

  ngOnInit(): void {
    this.postbackService.findAll({groups: 'goal,offers'}).subscribe((postbacks: Postback[]) => {
      this.postbacks = postbacks;
    });
  }
}
